import Icon from 'veui/components/Icon'
import { IconSquareRotation } from 'dls-icons-vue'

Icon.register('square-rotation', IconSquareRotation)
